// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3vJHi","title":"InfoRow_title__1hs3e"};